import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { identityClient } from '../sdk/identityClient.js';

/**
 * The Sign-in & security state: the Human's live connections. Kept out of the
 * session store on purpose — that store answers "who am I", this one answers
 * "which doors open me". (The "was this you?" proposal state was removed with
 * the proposal flow; a verified-email match is now handled at login by the
 * MATCH_FOUND screen.)
 */
export const linkingStore = defineStore('linkingStore', () => {
  const connections = ref([]);
  const loading = ref(false);
  const error = ref(null);

  // Item 6: the UI disables unlink on the only connection.
  const canUnlink = computed(() => connections.value.length > 1);

  async function refresh() {
    loading.value = true;
    error.value = null;
    try {
      const connectionsResult = await identityClient.getConnections();
      connections.value = connectionsResult?.connections ?? [];
    } catch (e) {
      error.value = e?.body?.error || 'LINKING_REFRESH_FAILED';
    } finally {
      loading.value = false;
    }
  }

  async function unlink(provider, subject) {
    const result = await identityClient.unlinkConnection(provider, subject);
    connections.value = result?.connections ?? connections.value;
    return connections.value;
  }

  return {
    connections,
    loading,
    error,
    canUnlink,
    refresh,
    unlink
  };
});
